import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  FormGroup,
  Label,
  Input,
  Button,
} from "reactstrap";
import { toast } from "react-toastify";

export const UpdateStatusOrderModal = ({
  shippingModalOpen,
  setShippingModalOpen,
  shippingStatus,
  setShippingStatus,
  shippingDescription,
  setShippingDescription,
  shippingTracking,
  setShippingTracking,
  selectedOrder,
  updateShippingStatus,
  markDelivered,
}) => {
  const handleShippingSubmit = async (e) => {
    e.preventDefault();

    if (!shippingStatus) {
      return toast.error("Debes seleccionar un estado");
    }

    // La actualización manual suele ser porque el cliente ya recibió el pedido:
    // pasa por markDelivered (fecha de entrega, pago, factura y puntos).
    if (shippingStatus === "DELIVERED") {
      return markDelivered({ id: selectedOrder.id });
    }

    if (shippingStatus === "SHIPPED" && !shippingTracking) {
      return toast.error("Debes ingresar el número de guía.");
    }

    const payload = {
      id: selectedOrder.id,
      status: shippingStatus,
      shippingDescription: shippingDescription,
      ...(shippingStatus === "SHIPPED" && { tracking: shippingTracking }),
    };

    await updateShippingStatus(payload);
  };

  return (
    <Modal
      isOpen={shippingModalOpen}
      toggle={() => setShippingModalOpen(!shippingModalOpen)}
      backdrop="static"
    >
      <ModalHeader toggle={() => setShippingModalOpen(false)}>
        Actualizar Estado de Envío
      </ModalHeader>
      <Form onSubmit={handleShippingSubmit}>
        <ModalBody>
          <FormGroup>
            <Label>Estado</Label>
            <Input
              type="select"
              value={shippingStatus}
              onChange={(e) => setShippingStatus(e.target.value)}
              required
            >
              <option value="">Seleccione</option>
              <option value="DELIVERED">Entregada</option>
              <option value="PROCESSING">En proceso</option>
              <option value="SHIPPED">Enviado</option>
            </Input>
          </FormGroup>

          {shippingStatus === "SHIPPED" && (
            <FormGroup>
              <Label>Número de Guía</Label>
              <Input
                type="text"
                value={shippingTracking}
                onChange={(e) => setShippingTracking(e.target.value)}
                placeholder="Ej: 1234567890"
                required
              />
            </FormGroup>
          )}

          {shippingStatus !== "DELIVERED" && (
          <FormGroup>
            <Label>Descripción del envío</Label>
            <Input
              type="textarea"
              rows="3"
              value={shippingDescription}
              onChange={(e) => setShippingDescription(e.target.value)}
            />
          </FormGroup>
          )}
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={() => setShippingModalOpen(false)}>
            <i className="fa fa-times me-1" /> Cancelar
          </Button>
          <Button color="info" type="submit">
            <i className="fa fa-truck me-1" /> Confirmar Estado
          </Button>
        </ModalFooter>
      </Form>
    </Modal>
  );
};
